import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { installReconnectCatchUp } from '../utils/reconnectCatchUp';

/** Данные обновляются сами, когда сеть вернулась, даже если приложение открыли уже без неё. */
export const useReconnectCatchUp = (): void => {
  const queryClient = useQueryClient();

  useEffect(() => installReconnectCatchUp(queryClient), [queryClient]);
};
